import { Col, Hr, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { P, Text } from "@amzn/stencil-react-components/text";
import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { getString } from "common/uistringlabels/uiStringUtils";
import { useProductFeedback } from "hooks/useProductFeedback";
import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalDomain, CatalogicalService } from "lib/services";
import { FeedbackModelRecord } from "lib/services/catalogical-models";
import { forEach } from "lodash";
import React, { FC, useEffect, useState } from "react";

import { ProductReviewCard, ReviewType } from "./ProductReviewCard";

export interface ProductReviewsListProps {
  domain: CatalogicalDomain;
  taxonomyId: TaxonomyIdItem;
  refreshTrigger?: number; //triggers reviews refresh
}

export const ProductReviewsList: FC<ProductReviewsListProps> = (props) => {
  const { productFeedback: feedback, error, isLoading, doGetFeedback } = useProductFeedback({ domain: props.domain });

  useEffect(() => {
    doGetFeedback({ taxonomyId: props.taxonomyId });
  }, [props.refreshTrigger]);

  const isValidReview = (feedback: FeedbackModelRecord) => {
    return feedback && feedback.content && feedback.content?.length > 0 && feedback.jobFamily;
  };

  const generateReviewCards = () => {
    const reviewCards: JSX.Element[] = [];
    feedback.forEach((feedback: FeedbackModelRecord) => {
      if (isValidReview(feedback)) {
        reviewCards.push(<Hr key={`hr-${feedback.feedbackId}`} />);
        reviewCards.push(
          <ProductReviewCard
            key={`review-${feedback.feedbackId}`}
            content={feedback.content!}
            jobFamily={feedback.jobFamily!}
          />
        );
      }
    });
    if (!feedback || feedback.length < 1 || reviewCards.length < 1) {
      reviewCards.push(NoReviews);
    }

    return reviewCards;
  };

  const renderLoadingComponent = () => {
    return (
      <Col alignItems="center" justifyContent="center" minHeight="400px">
        <Spinner size={SpinnerSize.Small} />
        <Text fontSize={"S100"}>{getString("productReviews.loading")}</Text>
      </Col>
    );
  };

  const NoReviews = (
    <View key="no-reviews" dataTestId="product-reviews-no-reviews">
      <Hr />
      <Text margin={"16px"}>{getString("productReviews.noReviews")}</Text>
    </View>
  );

  return (
    <Col dataTestId="product-reviews-list" height={"100%"} flex="1">
      {isLoading ? renderLoadingComponent() : generateReviewCards()}
    </Col>
  );
};
